export default (countries, { active }) =>
  countries.filter(country => {
    const activeMatch = typeof active !== 'undefined' ? country.active === active : true;
    return activeMatch;
  });
